import { onLogin } from '../me/login-event';

export let c_event_keywords: string[] = [];

export function cEventKeywordsRegister(keywords: string[]) {
    for(const k of keywords) {
        if(!c_event_keywords.includes(k))
            c_event_keywords.push(k);
    }

    c_event_keywords.sort();
}

onLogin(data => {
    if(data.keywords) {
        c_event_keywords = data.keywords || [];
        c_event_keywords.sort();
    }
});
